import type { IFeaturePermissionModel } from './Types';

const FeaturePermissionModel = (data: IFeaturePermissionModel) => {
  /**
   * From:
   *   key1: [{featureName}, ...]
   * To:
   *   key1: {[featureName]: {...}, ...}
   */
  const featurePermissions = {};
  for (const [key] of Object.entries(data.featurePermissions)) {
    featurePermissions[key] = data.featurePermissions[key].reduce(
      (permission, value) => ({ ...permission, [value.featureName]: value }),
      {},
    );
  }

  return { featurePermissions };
};

export default FeaturePermissionModel;
